module.exports = __webpack_public_path__ + "static/media/imp_hero.8f07b27b.png";